export default __webpack_public_path__ + "f18f6ff0a05085ed7d45b6ec3938e038.svg";